import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "px-4 sm:py-5 py-3 rounded-t-md flex items-center justify-between" }
const _hoisted_3 = {
  id: "applicant-information-title",
  class: "float-left sm:text-xl text-base font-bold text-gray-700"
}
const _hoisted_4 = { class: "hidden sm:block text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-red-700 px-4 pb-3 sm:pb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LiveBase = _resolveComponent("LiveBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white shadow sm:rounded-lg", _ctx.routerConnectionLostMessage ? 'bg-red-100' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.stream.name), 1),
        _createVNode(_component_router_link, {
          to: {
            name: 'Live',
            params: {
              camera_id: _ctx.stream.camera_id,
              customer_name: _ctx.stream.customer_name,
              site_id: _ctx.stream.site_id,
            },
          }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass([
              'flex items-center px-3 py-0.5 rounded-md',
              _ctx.routerConnectionLostMessage
                ? 'text-gray-700 hover:bg-red-200 hover:text-gray-900'
                : 'text-yellow-700 hover:bg-yellow-300 hover:text-yellow-900',
            ])
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.project.stream_card.detail_view")), 1),
              _createVNode(_component_ArrowRightIcon, {
                class: "ml-2 h-4 w-4",
                "aria-hidden": "true"
              })
            ], 2)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.routerConnectionLostMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.routerConnectionLostMessage), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_LiveBase, {
        cameraId: _ctx.stream.camera_id
      }, null, 8, ["cameraId"])
    ], 2)
  ]))
}